import React from 'react';
import { Link, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ListGroupItem } from '@cordata/buffet';
import { parse, format } from 'date-fns';

const AdmissionsListGroupItem = ({ data }) => {
  const params = useParams();
  const attributes = {
    ...(data && data.attributes),
    ...(data && data.relationships),
  };

  return (
    <ListGroupItem
      action
      tag={Link}
      to={`/patients/${params.patient_id || data.attributes.patientUid}/admissions/${data.id}`}
    >
      <span>
        <strong>{attributes.eventDate && format(parse(attributes.eventDate.split('T')[0], 'yyyy-MM-dd', new Date()), 'MM/DD/YY')}</strong>
        {' - '}{attributes.status.attributes.statusLabel}
        { attributes.facility ? (
          <span> { attributes.facility.attributes.facilityName }</span>
        ) : (
          <span> Uknown Facility</span>
        )}
      </span>
    </ListGroupItem>
  );
};

AdmissionsListGroupItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
};

export default AdmissionsListGroupItem;
